export default __webpack_public_path__ + "static/media/cert6.18380af0.jpg";